import { z } from "zod";

export const ImportWarningType = z.enum([
  "NoVersionFound",

  "UnsupportedFill",
  "UnsupportedStroke",
  "UnsupportedEffect",

  "NoPublishedElements",
  "NoPublishedStyles",
  "NoPublishedComponents",
  "NoPublishedAssets",

  "StyleNotApplied",

  "ComponentHasNoThumbnail",

  "DuplicateImportedStyleId",
  "DuplicateImportedStylePath",

  "NoUnpublishedStyles",

  "ReferenceResolutionFailed",
]);

export const ImportWarning = z.object({
  warningType: ImportWarningType,
  componentId: z.string().optional(),
  componentName: z.string().optional(),
  styleId: z.string().optional(),
  styleName: z.string().optional(),
  unsupportedStyleValueType: z.string().optional(),
  referenceId: z.string().optional(),
});

export type ImportWarningType = z.infer<typeof ImportWarningType>;
export type ImportWarning = z.infer<typeof ImportWarning>;
